import dayjs from 'dayjs'

import { Premise } from '@/api/models/auth/lib/auth.types'
import {
  PassAuto,
  RequestTypeAlias
} from '@/api/models/requests/lib/requests.types'
import { GUID_REGEX } from '@/app/constants/regex'
import { DEFAULT_TIMEZONE } from '@/components/entities/requests/model/constants'

export const getParkingPlaceName = (
  parkingPlace: string | null,
  premises: Premise[]
): string | null =>
  parkingPlace && GUID_REGEX.test(parkingPlace)
    ? premises.find(({ id }) => id === parkingPlace)?.name ?? ''
    : parkingPlace

export const getAutosWithParkingNames = (
  autos: PassAuto[],
  premises: Premise[]
): PassAuto[] =>
  autos.map(auto => ({
    ...auto,
    parkingPlace: getParkingPlaceName(auto.parkingPlace, premises)
  }))

export const getDisplayRequestDateEnd = (
  typeAlias: RequestTypeAlias,
  dateEnd: string
) =>
  typeAlias === RequestTypeAlias.RentPassAuto
    ? dayjs(dateEnd).subtract(1, 'minute').toISOString()
    : dateEnd

export const formatRequestDate = (dateString: string, hideToday = false) => {
  const date = dayjs(dateString).tz(DEFAULT_TIMEZONE)
  const now = dayjs().tz(DEFAULT_TIMEZONE)

  if (!hideToday && date.format('YYYY-MM-DD') === now.format('YYYY-MM-DD')) {
    return 'Сегодня'
  }

  const format =
    date.year() === now.year() ? 'D MMMM, HH:mm' : 'D MMMM YYYY, HH:mm'

  return date.format(format)
}
